export const transmissionMapper = {
  AutoClutch: "Auto Clutch",
  AutoManualMode: "Auto Manual Mode",
  CVTManualMode: "CVT Manual Mode",
  Unknown: null,
};

export const fuelMapper = {
  DieselCNG: "Diesel CNG",
  DieselElectric: "Diesel Electric",
  DieselLPG: "Diesel LPG",
  FuelCell: "Fuel Cell",
  PetrolCNG: "Petrol CNG",
  PetrolElectric: "Petrol Electric",
  PetrolLPG: "Petrol LPG",
};

export const paymentStatusMapper = {
  InvoiceNotPaid: {
    variant: "neutral",
    label: "Payment Due",
    backgroundColor: "rgba(191, 191, 191, 0.1);",
  },
  InvoicePaid: {
    variant: "positive",
    label: "Vehicle Paid",
    backgroundColor: "rgba(96, 152, 51, 0.07)",
  },
  PartnerFinanceInvoice: {
    variant: "positive",
    label: "Financed",
    backgroundColor: "rgba(191, 191, 191, 0.1);",
  },
  PartnerFinanceFailed: {
    variant: "negative",
    label: "Finance Failed",
    backgroundColor: "rgba(191, 191, 191, 0.1);",
  },
  PartnerFinanceProcessing: {
    variant: "warning",
    label: "Finance Processing",
    backgroundColor: "rgba(191, 191, 191, 0.1);",
  },
  Processing: {
    variant: "warning",
    label: "Payment Processing",
    backgroundColor: "rgba(238, 149, 4, 0.07)",
  },
  NoInvoice: {
    variant: "neutral",
    label: "Payment Due",
    backgroundColor: "rgba(238, 149, 4, 0.07)",
  },
  Failed: {
    variant: "negative",
    label: "Payment Failed",
    backgroundColor: "rgba(227, 6, 19, 0.07)",
  },
};

export const vatStatusMapper = {
  Qualifying: "VAT Qualifying",
  Marginal: "VAT Marginal",
  Commercial: "VAT Commercial",
  Unknown: null,
};

export const logbookMapper = {
  true: "Present",
  false: "Not Present",
};
